<template>
    <div class="container">
        <div class="row">
            <div class="twelve columns"><h1>Logoff</h1></div>
        </div>
        <div v-if="this.canLogoff() === false" class="row">
            <div class="three columns">&nbsp; </div>
            <div class="nine columns"><b>You are logged-off!</b></div>
        </div>
        <div v-if="this.canLogoff() === true" class="row">
            <div class="three columns">&nbsp; </div>
            <div class="nine columns heigh-line">Click the <a href="#">Logoff</a> button to quit your session.</div>
        </div>
        <div v-if="this.canLogoff() === true" class="row">
            <div class="three columns">&nbsp; </div>
            <div class="nine columns"><button @click="runLogoff" class="button button-primary">Logoff</button></div>
        </div>

    </div>
</template>

<script>
// import { checkUserLogin } from '../services/helper-fido2.js'
export default {
    name: 'PageLogoff',
    methods: {
        canLogoff: function () {
            return (
                this.$parent.$data.current.user !== null
            )
        },
        runLogoff: function (event) {
            if (window.location.protocol === 'https:' || window.location.hostname === 'localhost') {
                // $$$ TODO: call Logoff API
                // $$$
                debugger // eslint-disable-line no-debugger
                let userId = this.$parent.$data.current.user.UserId || null
                let token = this.$parent.$data.current.user.token || null
                console.log(`PageLogoff.runLogof(): userId:`, userId)
                console.log(`PageLogoff.runLogof(): token:`, token)
                return this.webapi$logoff(userId, token)
                    .then(json => {
                        //
                        this.$parent.$data.current.user = null
                    })
                    .catch(err => {
                        this.$parent.$data.current.user = null
                        console.error(err)
                    })
            }
        }
    }
}
</script>

<style scope>
    .heigh-line {
        height: 52px;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/PageLogoff.vue